import './Style.scss';
import { getLocalization } from 'global/global';
import * as React from 'react';
import { Button, Table } from 'react-bootstrap';
import { getDetailedAiUsage } from 'actions/adminActions';
import { AiUserUsageInterface } from 'Interfaces/AiUserUsageInterface';
import GenericModal from 'views/Modals/GenericModal';
import { /* MONTHS, */ MONTHS_CODE } from 'utils/utils';

interface Props {
  visible: boolean;
}

export default function DetailedAiUsage({ visible }: Props) {

  const [usage, setUsage] = React.useState<null | AiUserUsageInterface[]>(null);
  const [loading, setLoading] = React.useState(false);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (!usage && !loading) {
      setLoading(true);
      getDetailedAiUsage().then(json => {
        if (Array.isArray(json)) {
          setUsage(json);
          setLoading(false);
        } else {
          setUsage([]);
          setLoading(false);
        }
      }).catch(() => {
        setUsage([]);
        setLoading(false);
      });
    }
  }, [show]);

  if (!visible) {
    return null;
  }

  const body = (
    <div className="detailed-ai-usage">
      <Table striped={true} bordered={true}>
        <thead>
          <tr>
            <th>#</th>
            <th>{getLocalization('userName')}</th>
            <th>{getLocalization('feature')}</th>
            <th>{getLocalization('usage')}</th>
            <th>{getLocalization('month')}</th>
            <th>{getLocalization('year')}</th>
          </tr>
        </thead>
        <tbody>
          {usage?.map((u, i) => (
            <tr key={`${i}-${u.userName}-${u.month}-${u.year}`}>
              <td>{i + 1}</td>
              <td>{u.userName}</td>
              <td>{u.feature}</td>
              <td>${u.usage}</td>
              <td>{getLocalization(MONTHS_CODE[u.month - 1])}</td>
              <td>{u.year}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );

  const modal = show ? (
    <GenericModal
      visible={show}
      body={body}
      onConfirm={() => setShow(false)}
      confirmText={getLocalization('close')}
      title={getLocalization('detailedUsage')}
      dialogClassName={'modal-xl'}
    />
  ) : null;

  return (
    <div className="ai-usage-dropdown ms-2">
      {modal}
      <Button
        size="sm"
        onClick={() => setShow(true)}
      >
        {getLocalization('detailedUsage')}
      </Button>
    </div>
  );
}
